import { Rate, LEVEL } from "./common";
import { fmtIDR } from "../util";
import Coaching from "./ai/Coaching";

const L = ({ k, v, testid }) => <div className="flex justify-between gap-3 text-[13px] py-0.5" data-testid={testid}><span className="text-neutral-500">{k}</span><span className="tabular-nums text-right">{v}</span></div>;
const H = ({ children }) => <div className="text-xs font-semibold text-neutral-600 mt-3 mb-1 border-b border-neutral-200 pb-1">{children}</div>;
const pctOr = (v) => (v == null ? "—" : `${v}%`);

function AdsPerformance({ a }) {
    if (!a?.rows?.length) return null;
    return (
        <div data-testid="sum-ads-performance">
            <H>Ads Performance</H>
            {!a.available && <p className="text-[11px] text-neutral-500 mb-1" data-testid="sum-ads-na">Closing per Ads: Data tidak tersedia</p>}
            <table className="w-full table-fixed text-[13px] tabular-nums">
                <thead><tr className="text-[10px] uppercase tracking-wide text-neutral-500"><th className="text-left font-medium w-[46%]">Ads / Product</th><th className="text-right font-medium">Ads Leads</th><th className="text-right font-medium">Closing</th><th className="text-right font-medium">Rate</th></tr></thead>
                <tbody>
                    {a.rows.map((r, i) => (
                        <tr key={i} data-testid={`sum-ads-row-${i}`}>
                            <td className="py-0.5 pr-1 truncate" title={r.name}>{r.name}</td>
                            <td className="text-right">{r.chats}</td>
                            <td className="text-right" data-testid={`sum-ads-closing-${i}`}>{r.closing ?? "—"}</td>
                            <td className="text-right" data-testid={`sum-ads-rate-${i}`}>{pctOr(r.rate)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="mt-1 border-t border-dashed border-neutral-200 pt-1">
                <L k="Total Ads Leads" v={a.total_chat} testid="sum-ads-total-chat" />
                <L k="Total Ads Closing" v={a.total_closing ?? "—"} testid="sum-ads-total-closing" />
                <L k="Overall Ads Closing Rate" v={<b>{pctOr(a.overall_rate)}</b>} testid="sum-ads-overall-rate" />
                {a.available && !a.complete && <p className="text-[11px] text-neutral-500" data-testid="sum-ads-partial">Sebagian baris Ads belum diisi closing.</p>}
            </div>
        </div>
    );
}

export default function PicSummary({ p }) {
    const d = p.data, s = p.summary;
    const msgColor = LEVEL[s.ready_level]?.[1] === "bg-emerald-600" || s.po_level === "GREEN" ? "text-emerald-700" : s.ready_level === "ORANGE" || s.po_level === "ORANGE" ? "text-orange-600" : "text-rose-700";
    return (
        <div className="bg-white text-ink mx-auto w-full max-w-[400px] border border-neutral-200 px-5 py-5 font-sans" data-testid="pic-summary">
            <div className="text-center">
                <div className="text-[11px] tracking-[0.3em] font-semibold">H&T GROUP</div>
                <div className="text-base font-semibold tracking-wide">DAILY PIC REPORT</div>
            </div>
            <div className="mt-3 text-[13px] space-y-0.5">
                <L k="Tanggal" v={p.reporting_date} /><L k="PIC" v={p.user_name} testid="sum-pic" /><L k="Shift" v={s.shift_label} testid="sum-shift" />
                <L k="Status" v={{ APPROVED: "Approved", RETURNED: "Dikembalikan", DRAFT: "Draft" }[p.status] || "Submitted"} testid="sum-status" />
            </div>
            <H>Chat Handled</H>
            <L k="Kommo" v={d.chat_kommo} /><L k="Instagram" v={d.chat_instagram} /><L k="TOTAL CHAT HANDLED" v={<b>{s.total_chat}</b>} testid="sum-total-chat" />
            <L k="Comment Dibalas" v={d.comment_replied ?? "—"} testid="sum-comment-replied" />
            <H>Rate Closing Harian</H>
            <L k="Rate Ready" v={<Rate value={s.ready_rate} lvl={s.ready_level} testid="sum-ready-rate" />} />
            <L k="Rate PO" v={<Rate value={s.po_rate} lvl={s.po_level} testid="sum-po-rate" />} />
            <L k="Closing Ready" v={`${d.ready_count} · ${fmtIDR(d.ready_idr)}`} />
            {(d.po_rows || []).filter((r) => r.count || r.idr).map((r) => <L key={r.country} k={`Closing PO ${r.country}`} v={`${r.count} · ${fmtIDR(r.idr)}`} />)}
            <L k="Total Closing PO" v={`${d.po_count} · ${fmtIDR(d.po_idr)}`} />
            <L k="TOTAL NOMINAL PIC" v={<b>{fmtIDR(s.closing_total_idr)}</b>} testid="sum-total-nominal" />
            {s.over_100 && <p className="text-[11px] text-neutral-500">Rate di atas 100%: closing bisa berasal dari chat hari sebelumnya.</p>}
            <AdsPerformance a={s.ads_performance} />
            <H>Follow-Up</H>
            {d.fu_source === "LOG"
                ? <L k="Follow-up (dari Follow-up Log)" v={`${d.fu_sales_selesai} follow-up · ${d.fu_sales_belum} pengingat belum selesai`} testid="sum-fu-log" />
                : <L k="Sales: wajib / selesai / belum" v={`${d.fu_sales_wajib} / ${d.fu_sales_selesai} / ${d.fu_sales_belum}`} />}
            <L k="Action: total / selesai / belum" v={`${d.fu_action_total} / ${d.fu_action_selesai} / ${d.fu_action_belum}`} />
            {(s.fu_warnings || []).map((w) => <p key={w} className="text-[11px] text-amber-700" data-testid="sum-fu-warning">{w}</p>)}
            {d.followups.length > 0 && <><H>Follow-up Customer</H>{d.followups.map((f) => <div key={f.uid} className="text-[13px] py-0.5">{f.customer} — {f.task}{f.deadline ? ` (s/d ${f.deadline})` : ""}</div>)}</>}
            {s.handover_groups.map((g) => (
                <div key={g.recipient} data-testid={`sum-handover-${g.recipient}`}>
                    <H>Handover ke {g.recipient}</H>
                    {g.items.map((h) => <div key={h.uid} className="text-[13px] py-0.5 flex justify-between gap-2"><span>{h.customer} — {h.task}{h.deadline ? ` (s/d ${h.deadline})` : ""}</span><span className={`text-[10px] font-semibold ${h.status === "DONE" ? "text-emerald-700" : "text-amber-700"}`}>{h.status === "CANCELLED" ? "BATAL" : h.status}</span></div>)}
                </div>
            ))}
            <Coaching p={p} fallback={s.message} legacy={<p className={`mt-4 text-center text-[13px] font-medium ${msgColor}`} data-testid="sum-message">{s.message}</p>} />
        </div>
    );
}
